import apiClient from "../../../api/apiClient";
import { DeviceType } from "../../../models/constants/deviceType";
import { UnifiedResponse } from "../../../models/Response/unifiedResponse";
import {
  GameListRequest, FreespinUserRequest, QtechFreeSpinPromoCodeRequest, GameLaunchRequest, UsersFavouriteGameRequest, GameDetailsRequest,
  GetQtechFreeSpinRequest, QtechFreeSpinCreateRequest, RetrieveTrendingGamesRequest
} from "../models/requests/index";
import {
  GameDetailsModel, GameListResponse, SupplierListResponse, GetQtechFreeSpinResponse, FreeSpinGameResponse, QtechGameResponse, UserSegmentationDetailsResponse,
  QtechFreespinGames, GameCategoryListResponse,
  GameDataList
} from "../models/responses/index";


export const casinoApi = {
  /* Game Category List */
  loadGameCategory: async (): Promise<
    UnifiedResponse<GameCategoryListResponse>
  > => {
    const response = await apiClient.post<
      UnifiedResponse<GameCategoryListResponse>
    >("game/categorylist/retrieve", {});

    return response.data;
  },

  /* Load Game Data */
  loadGameList: async (
    request: GameListRequest,
  ): Promise<UnifiedResponse<GameListResponse>> => {
    const response = await apiClient.post<UnifiedResponse<GameListResponse>>(
      "game/list/retrieve",
      request,
    );

    return response.data;
  },

  /* Load Supplier List */
  retrieveSupplierList: async (
    categoryId: string | null = null,
  ): Promise<UnifiedResponse<SupplierListResponse>> => {
    const requestObject = { CategoryId: categoryId };

    const response = await apiClient.post<
      UnifiedResponse<SupplierListResponse>
    >("game/supplierlist/retrieve", requestObject);

    return response.data;
  },
  /* Segmentation by user */
  retrieveSegmentationByUser: async (): Promise<
    UnifiedResponse<UserSegmentationDetailsResponse>
  > => {
    const response = await apiClient.post<
      UnifiedResponse<UserSegmentationDetailsResponse>
    >("banner/retrieve_segmentation_by_user", {});

    return response.data;
  },

  /* Update favourite game */
  updateFavouriteGame: async (
    request: UsersFavouriteGameRequest,
  ): Promise<UnifiedResponse<unknown>> => {
    const response = await apiClient.post<UnifiedResponse<unknown>>(
      "users/favourite_game",
      request,
    );    
    return response.data;
  },

  /* Game Details Retrieve */
  getGameDetails: async (
    request: GameDetailsRequest,
  ): Promise<UnifiedResponse<GameDetailsModel>> => {
    const response = await apiClient.post<UnifiedResponse<GameDetailsModel>>(
      "game/details/retrieve",
      request,
    );
    return response.data;
  },
  /** Qtech Free Spin Games */
  qtechFreeSpinGames: async (
    request: FreespinUserRequest,
  ): Promise<UnifiedResponse<QtechFreespinGames>> => {
    const response = await apiClient.post<UnifiedResponse<QtechFreespinGames>>(
      "users/freespingames_by_id",
      request,
    );

    return response.data;
  },

  /* Get Latest Qtech Promo Code */
  getLatestPromoCode: async (
    request: QtechFreeSpinPromoCodeRequest,
  ): Promise<UnifiedResponse<FreeSpinGameResponse>> => {
    const response = await apiClient.post<
      UnifiedResponse<FreeSpinGameResponse>
    >("bonus/qtech/get_latest_promocode", request);

    return response.data;
  },
  /* Qtech Game Launch */
  launchQtechGame: async (
    request: GameLaunchRequest,
  ): Promise<UnifiedResponse<QtechGameResponse>> => {
    // Match backend logic: AccessMode == 2 → mobile
    if (request.accessMode === 2) {
      request.device = DeviceType.Mobile.toLowerCase();
    }

    const response = await apiClient.post<UnifiedResponse<QtechGameResponse>>(
      "game/qtech/launch_url",
      request,
    );

    return response.data;
  },

  /* Get Qtech Free Rounds */
  getQtechFreeRounds: async (
    request: GetQtechFreeSpinRequest,
  ): Promise<UnifiedResponse<GetQtechFreeSpinResponse>> => {
    const response = await apiClient.post<
      UnifiedResponse<GetQtechFreeSpinResponse>
    >("bonus/qtech/get-free-rounds", request);
    return response.data;
  },

  /* Qtech Free Spin Create */
  qtechFreeSpinCreate: async (
    request: QtechFreeSpinCreateRequest,
  ): Promise<UnifiedResponse<unknown>> => {
    const response = await apiClient.post<UnifiedResponse<unknown>>(
      "bonus/qtech/free-rounds",
      request,
    );
    return response.data;
  },

  fetchRecentlyPlayedGames: async (): Promise<UnifiedResponse<GameListResponse>> => {
    const response = await apiClient.get<UnifiedResponse<GameListResponse>>(
      "game/retrieve_recently_played/list",
    );
    return response.data;
  },

  fetchTrendingGames: async (
    request?: RetrieveTrendingGamesRequest,
  ): Promise<UnifiedResponse<GameListResponse>> => {
    const response = await apiClient.post<UnifiedResponse<GameListResponse>>(
      "game/retrieve_trending/list",
      request,
    );
    return response.data;
  },
};
